// extracted by mini-css-extract-plugin
export default {"root":"EditListingTypeOfCuisinePanel_root__9jidu","form":"EditListingTypeOfCuisinePanel_form__N5MUr","title":"EditListingTypeOfCuisinePanel_title__d0c8e"};